export default function Footer() {
  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#050714] relative overflow-hidden">
      {/* Dot grid pattern */}
      <div className="absolute inset-0 opacity-5 pointer-events-none"
        style={{ backgroundImage: 'radial-gradient(circle, rgba(139,92,246,0.5) 1px, transparent 1px)', backgroundSize: '30px 30px' }}>
      </div>
      {/* Glow */}
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] rounded-full bg-violet-600/5 blur-3xl pointer-events-none"></div>

      <div className="max-w-7xl mx-auto px-6 md:px-10 relative z-10">
        {/* Upper */}
        <div className="py-16 md:py-20 flex flex-col lg:flex-row gap-12 lg:gap-16">
          {/* Brand */}
          <div className="lg:w-80 flex-shrink-0">
            <div className="flex items-center gap-3 mb-6">
              <img
                src="https://public.readdy.ai/ai/img_res/32bb7955-927e-461e-9db0-09455eaedac3.png"
                alt="Silo Intelligence"
                className="h-[120px] w-[120px] object-contain"
              />
            </div>
            <p className="text-white/35 text-sm leading-relaxed mb-6">
              Intelligent systems designed for clarity, control, and growth. We eliminate fragmentation at the system level.
            </p>
            <a
              href="mailto:contact@silointelligence.ai"
              className="flex items-center gap-2 text-violet-400/80 hover:text-violet-400 text-sm transition-colors"
            >
              <i className="ri-mail-line text-base"></i>
              <span>contact@silointelligence.ai</span>
            </a>
          </div>

          {/* Nav grid */}
          <div className="flex-1 grid grid-cols-2 sm:grid-cols-4 gap-8">
            <div>
              <p className="text-white/50 text-xs font-semibold uppercase tracking-widest mb-4">Platform</p>
              <ul className="flex flex-col gap-3">
                {['AI Voice Agents', 'Unified CRM', 'Automation', 'Pipeline'].map((item) => (
                  <li key={item}>
                    <button
                      onClick={() => scrollTo('features')}
                      className="text-white/35 hover:text-white/65 text-sm transition-colors cursor-pointer text-left"
                    >
                      {item}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="text-white/50 text-xs font-semibold uppercase tracking-widest mb-4">Industries</p>
              <ul className="flex flex-col gap-3">
                {['Home Services', 'Legal', 'Healthcare', 'Real Estate', 'Finance'].map((item) => (
                  <li key={item}>
                    <button
                      onClick={() => scrollTo('industries')}
                      className="text-white/35 hover:text-white/65 text-sm transition-colors cursor-pointer text-left"
                    >
                      {item}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="text-white/50 text-xs font-semibold uppercase tracking-widest mb-4">Company</p>
              <ul className="flex flex-col gap-3">
                {['About', 'Process', 'Case Studies', 'Contact'].map((item) => (
                  <li key={item}>
                    <button
                      onClick={() => scrollTo('cta')}
                      className="text-white/35 hover:text-white/65 text-sm transition-colors cursor-pointer text-left"
                    >
                      {item}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="text-white/50 text-xs font-semibold uppercase tracking-widest mb-4">Connect</p>
              <ul className="flex flex-col gap-3">
                <li>
                  <a href="mailto:contact@silo-intelligence.com" className="text-white/35 hover:text-white/65 text-sm transition-colors">Email Us</a>
                </li>
                <li>
                  <button onClick={() => scrollTo('cta')} className="text-white/35 hover:text-white/65 text-sm transition-colors cursor-pointer text-left">
                    Book a Call
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/6"></div>

        {/* Bottom bar */}
        <div className="py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/20 text-xs">
            &copy; {new Date().getFullYear()} Silo Intelligence. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            {['ri-linkedin-box-line', 'ri-twitter-x-line', 'ri-instagram-line'].map((icon) => (
              <a
                key={icon}
                href="#"
                className="w-8 h-8 flex items-center justify-center rounded-lg border border-white/8 text-white/25 hover:text-white/55 hover:border-white/20 transition-all cursor-pointer"
              >
                <i className={`${icon} text-sm`}></i>
              </a>
            ))}
          </div>
          <div className="flex items-center gap-4">
            <a href="#" className="text-white/20 hover:text-white/45 text-xs transition-colors" rel="nofollow">Privacy Policy</a>
            <a href="#" className="text-white/20 hover:text-white/45 text-xs transition-colors" rel="nofollow">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
